import { Tabs, Tab, Box } from "@mui/material";
import CustomTabPanel from "../components/custom-tab-panel";
import { useState } from "react";
import { useAppSelector } from "../app/hooks";
import { selectLoggedInUser } from "../features/auth/auth.slice";
import { AccountCircleIcon, EventAvailableIcon } from "../shared/icons";
import UserForm from "../features/user/components/user-form";
import { UserType } from "../shared/enums";
import MyAttendance from "../features/profile/my-attendance";

const Profile = () => {
    const [value, setValue] = useState(0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const loggedInUserDetails = useAppSelector(selectLoggedInUser);

    const getUserBasedOnType = () => {
        if (loggedInUserDetails?.type === UserType.BUSINESS_USER) {
            return loggedInUserDetails?.roleData?.businessUser;
        } else if (loggedInUserDetails?.type === UserType.MEMBER) {
            return loggedInUserDetails?.roleData?.member;
        } else if (loggedInUserDetails?.type === UserType.GYMINIFY) {
            return loggedInUserDetails?.roleData?.admin;
        }
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} variant="fullWidth" onChange={handleChange} aria-label="profile tabs">
                    <Tab icon={<AccountCircleIcon />} label="Profile" iconPosition="start" />
                    {loggedInUserDetails?.type === UserType.BUSINESS_USER && (
                        <Tab icon={<EventAvailableIcon />} label="Attendance" iconPosition="start" />
                    )}
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                {loggedInUserDetails &&
                    <UserForm userType={loggedInUserDetails.type} isProfile={true} user={getUserBasedOnType()} editable={true} onClose={() => { }} />
                }
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <MyAttendance />
            </CustomTabPanel>
        </Box>
    )
}

export default Profile;